module.exports = __webpack_public_path__ + "media/src/images/landing/dashboard-chart-9f23396336bf1e7a3269416264d36544.png";